import { logEvent } from '.';

const generalInfoTrackingEvents = {
  title: {
    added: 'PROFILE_GENERAL_INFORMATION_TITLE_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_TITLE_EDITED',
    removed: ''
  },
  profilePicture: {
    added: 'PROFILE_GENERAL_INFORMATION_PROFILE_PICTURE_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_PROFILE_PICTURE_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_PROFILE_PICTURE_REMOVED'
  },
  fullName: {
    added: 'PROFILE_GENERAL_INFORMATION_FULL_NAME_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_FULL_NAME_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_FULL_NAME_REMOVED'
  },
  firstName: {
    added: 'PROFILE_GENERAL_INFORMATION_FIRST_NAME_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_FIRST_NAME_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_FIRST_NAME_REMOVED'
  },
  lastName: {
    added: 'PROFILE_GENERAL_INFORMATION_LAST_NAME_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_LAST_NAME_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_LAST_NAME_REMOVED'
  },
  pronouns: {
    added: 'PROFILE_GENERAL_INFORMATION_PRONOUNS_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_PRONOUNS_EDITED',
    removed: ''
  },
  headline: {
    added: 'PROFILE_GENERAL_INFORMATION_HEADLINE_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_HEADLINE_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_HEADLINE_REMOVED'
  },
  countryAlpha2: {
    added: 'PROFILE_GENERAL_INFORMATION_COUNTRY_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_COUNTRY_EDITED',
    removed: ''
  },
  twitter: {
    added: 'PROFILE_GENERAL_INFORMATION_TWITTER_PROFILE_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_TWITTER_PROFILE_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_TWITTER_PROFILE_REMOVED'
  },
  linkedin: {
    added: 'PROFILE_GENERAL_INFORMATION_LINKEDIN_PROFILE_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_LINKEDIN_PROFILE_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_LINKEDIN_PROFILE_REMOVED'
  },
  profilePictureURL: {
    added: 'PROFILE_GENERAL_INFORMATION_PROFILE_PICTURE_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_PROFILE_PICTURE_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_PROFILE_PICTURE_REMOVED'
  },
  websiteLinks: {
    added: 'PROFILE_GENERAL_INFORMATION_WEBSITE_ADDED',
    edited: 'PROFILE_GENERAL_INFORMATION_WEBSITE_EDITED',
    removed: 'PROFILE_GENERAL_INFORMATION_WEBSITE_REMOVED'
  }
};

export const generalInfoFields = Object.keys(generalInfoTrackingEvents);

export const handleGeneralInfoTracking = (
  field: string,
  oldValue: any,
  newValue: any
) => {
  if (oldValue === newValue) return;

  if (
    ['string', 'boolean'].includes(typeof oldValue) ||
    ['string', 'boolean'].includes(typeof newValue)
  ) {
    if (!oldValue && !newValue) return;
    if (!oldValue && newValue)
      logEvent((generalInfoTrackingEvents as any)[field].added, {
        value: newValue
      });
    else if (oldValue && !newValue)
      logEvent((generalInfoTrackingEvents as any)[field].removed);
    else if (oldValue !== newValue)
      logEvent((generalInfoTrackingEvents as any)[field].edited, {
        oldValue,
        newValue
      });
  } else if (field === 'primaryAffiliation') {
    handleGeneralInfoTracking(
      field,
      oldValue.affiliationId,
      newValue.affiliationId
    );
  } else if (['websiteLinks', 'research'].indexOf(field) !== -1) {
    handleGeneralInfoTracking(
      field,
      !oldValue.length
        ? null
        : JSON.stringify(oldValue.sort((a: any, b: any) => b.url - a.url)),
      !newValue.length
        ? null
        : JSON.stringify(newValue.sort((a: any, b: any) => b.url - a.url))
    );
  }
};
